// "Kitchen" is used to refer to the backend, and "restaurant" is used to refer to the establishment.
const companyName: string = 'Tap Menu';

export default {
  de: {},
  es: {},
  fr: {},
  zh: {},
  fi: {},
  sv: {},
  en: {
    howDoIUseThisAppDescriptionRegular: `<p>This is an app that allows you to order for yourself and others using your phone. It begins on the "Menu" page where you can view and select the items that you wish to add to your order. After you’ve picked everything that you want you can go to the “Order” page and click “Send Order” to send your order to the kitchen. The kitchen will be notified of this and accept your order if they are able to prepare it. Once accepted, you will receive a notification of this. You can see all notifications sent and received on the “Messages” page. On this page you can also make other requests, such as requesting more napkins or water, or ask questions and give feedback.</p><p>Once you’re ready to pay your bill, you can request the bill on the “Pay” page. You can request the full bill, a partial bill, or a split bill depending on if you’re ordering for just yourself or for a larger party. That said, multiple people at your table can use this app at the same time to speed up the ordering process. Orders are aggregated on a per table basis. Eventually, you’ll be able to pay for your bill directly in the app as well.</p><p>Thanks for using ${companyName}.</p><p>Want ${companyName} in your restaurant? Visit <a href="tapmenu.ca" target="_blank">tapmenu.ca</a> for details.</p>`,
    howDoIUseThisAppDescriptionTakeout: `<p>Thanks for using ${companyName} for takeout.</p><p>Thanks for using ${companyName}.</p><p>Want ${companyName} in your restaurant? Visit <a href="tapmenu.ca" target="_blank">tapmenu.ca</a> for details.</p>`,
    howDoIUseThisAppDescriptionDelivery: `<p>Thanks for using ${companyName} for delivery.</p><p>Want ${companyName} in your restaurant? Visit <a href="tapmenu.ca" target="_blank">tapmenu.ca</a> for details.</p>`,
    aboutUs: `About {0}`,
    addedToOrder: `{0} was added to your order.`,
    addedToYourOrder: `{0} added to your pending order.`,
    addToOrder: `Add to Order`,
    alcoholic: `Alcoholic`,
    apply: `Apply`,
    asManyAsYoudLike: `Choose as many as you'd like.`,
    attributes: `Attributes`,
    callServer: `Call Server`,
    calories: `Calories`,
    caloriesExplicit: `Calories`,
    canOnlySelectMaxOptions: `Can only select {0}. Unselect other options to pick this one.`,
    choose: `Choose {0}.`,
    chooseUpTo: `Choose up to {0}.`,
    clear: `Clear`,
    clearAll: `Clear Order`,
    codeIsInvalid: `Invalid code! Please recheck your entry or notify the staff if the entry was correct.`,
    cold: `Cold`,
    confirmPassword: `Confirm Password`,
    dairyFree: `Dairy Free`,
    done: `Done`,
    dontWant: `Don't want`,
    email: `Email`,
    enterACode: `Enter a code.`,
    explainTemperatureRange: `0 = Cold / 1 = Room temperature / 2 = Hot`,
    false: `False`,
    filters: `Filters`,
    filtersDescription: `Limit what you see in the menu by selecting your preferences here.`,
    getApp: `Get App`,
    getAppSafari: `Tap the share button at the botom of the screen. Then tap "Add to Home Screen".`,
    glutenFree: `Gluten Free`,
    halal: `Halal`,
    healthy: `Healthy`,
    info: `Info`,
    hot: `Hot`,
    howDoIUseThisApp: `How Do I Use This App?`,
    IDontWantAny: `None`,
    IJustWant: `I just want {0}`,
    itemOptions: `Item Options`,
    kosher: `Kosher`,
    max: `Max`,
    medium: `Medium`,
    menu: `Menu`,
    mild: `Mild`,
    min: `Min`,
    mustBeAValidEmail: `Must be a valid email`,
    miscellaneous: `Miscellaneous`,
    multipleOfSingleOption: `Repeatedly select an item to increase the quantity.`,
    mustChoose: `Must choose {0} from {1}.`,
    mustChooseOrOptOut: `Must choose {0} from {1} or select the {2} option.`,
    no: `No`,
    noneSelected: `None Selected`,
    noOrders: `No order to send. To add to your order, go to the menu page and add the menu items you wish to order.`,
    notProvided: `-`,
    off: `Off`,
    on: `On`,
    orders: `Orders`,
    messageSent: `Your {0} was sent to the kitchen.`,
    password: `Password`,
    pay: `Pay`,
    payTutorial: `Pay instantly through this app`,
    payFullNow: `Pay Full Bill`,
    payFullNowTutorial: `Pay for the full bill through this app`,
    payPartialNow: `Pay Partial Bill`,
    payPartialNowTutorial: `Pay for a partial bill through this app`,
    okay: `Okay`,
    peanutFree: `Peanut Free`,
    spicy: `Spicy`,
    price: `Price`,
    displayPrice: `Price`,
    range: `{0} Range`,
    removeItem: `Remove Item`,
    requestBill: `Request Bill`,
    requestBillTutorial: `Request the full remaining bill`,
    billBreakdown: `Bill Breakdown`,
    requestFullBill: `Request Full Bill`,
    requestPartialBill: `Request Partial Bill`,
    requestPartialBillTutorial: `Pay for a portion of the items ordered`,
    requestBillChunked: `Request Split Bill`,
    requestBillChunkedTutorial: `Group items for separate payments`,
    requestNapkins: `Request Napkins`,
    requestSomethingElse: `Request Something Else`,
    requestWater: `Request Water`,
    room: `Room`,
    samePlace: `Same Place?`,
    scorching: `Scorching`,
    billAccordionTutorial: `Tap a bill below for more details.`,
    sendOrder: `Send Order`,
    messages: `Messages`,
    serves: `Serves`,
    settings: `Settings`,
    adjustFilters: `Adjust Filters`,
    showImage: `Show Image`,
    showImages: `Show Images`,
    showIndeterminate: `Show Indeterminate`,
    side: `Side`,
    size: `Size`,
    sliders: `Sliders`,
    temperature: `Temp`,
    thisMenuItemIs: `This item is...`,
    useTheKeyboardBelow: `Use the keyboard below to enter your code.`,
    vegetarian: `Vegetarian`,
    veryHot: `Very Hot`,
    want: `Want`,
    webSearch: `Web Search`,
    yes: `Yes`,
    explainShowIndeterminate: `Check this to show menu items that have an indeterminate status in regards to your selected attributes. For example, items that are not specified to be either vegetarian or non-vegetarian will still show up even if you select vegetarian only.`,
    noMenuItemsToShow: `No menu items to show. Your search filters may be too restrictive.`,
    sendMessage: `Send Message`,
    sendMessageTutorial: `Send a question, give feedback etc.`,
    callServerMessage: `Could someone please come over to my table?`,
    requestWaterMessage: `May I please have some water?`,
    requestNapkinsMessage: `May I please have some napkins?`,
    requestSomethingElseMessage: `May I please have `,
    requestBillMessage: `May I please have the bill?`,
    noTablesideAcceptedOrdersForBills: `Once an order has been accepted by the back end, you will be able to pay or request your bill here. You can request the full bill, a partial bill, or a split bill.`,
    send: `Send`,
    saveChanges: `Save Changes`,
    toBeSentTitle: `Ready to Send`,
    acceptedTitle: `Accepted`,
    rejectedTitle: `Rejected`,
    cancelledTitle: `Cancelled`,
    pendingTitle: `Pending`,
    acceptedBills: `Accepted Bills`,
    rejectedBills: `Rejected Bills`,
    cancelledBills: `Cancelled Bills`,
    pendingBills: `Pending Bills`,
    acceptedMessage: `Your {0} has been accepted.`,
    billAccepted: `A bill for these items will be brought to you.`,
    complimentsToTheChef: `Compliments to the Chef!`,
    complimentsToTheChefMessage: `Compliments to the chef!`,
    tapFiltersToRemoveThem: `Tap the tags below to remove filters.`,
    inconsequential: `Inconsequential`,
    cancelItem: `Cancel Item`,
    requestCancellationOfItem: `Request Cancellation of Item`,
    reorderItem: `Reorder Item`,
    makeARequest: `Make a Request`,
    giveFeedback: `Give Feedback`,
    askQuestion: `Ask Question`,
    orderAccepted: `Your order was accepted.`,
    requestAccepted: `Your request has been acknowledged.`,
    answerReceived: `An answer to your question has been received`,
    orderRejected: `Your order could not be fulfilled. See the message page for the reason.`,
    requestRejected: `Your request could not be fulfilled. See the message page for the reason.`,
    answerRejected: `Unfortunately, your question could not be answered.`,
    orderCancelled: `Your previously accepted order was cancelled. See the message page for the reason.`,
    sentNotifications: `Sent`,
    receivedNotifications: `Received`,
    reorderLast: `Reorder Last`,
    reorderLastTutorial: `Queue the last order sent.`,
    generalNotificationMessage: `Your {0} was {1}.`,
    notificationDetails: `Notification Details`,
    rejectionReason: `Your {0} was rejected.`,
    cancelledReason: `Your previously accepted {0} was cancelled.`,
    status: `status`,
    pending: `created`,
    accepted: `accepted`,
    rejected: `rejected`,
    paused: `paused`,
    cancelled: `cancelled`,
    privileged: `privileged`,
    order: `order`,
    tablesideOrder: `tableside order`,
    deliveryOrder: `delivery order`,
    takeoutOrder: `takeout order`,
    orderAheadOrder: `Order ahead request`,
    bill: `bill`,
    cancellationRequest: `cancellation`,
    request: `request`,
    question: `question`,
    questionAnswered: `Question answered`,
    feedback: `feedback`,
    payment: `payment`,
    noReason: `No reason given.`,
    message: `message`,
    newNotification: `New {0} from station {1}`,
    confirm: `Confirm?`,
    youAsked: `You asked`,
    theySaid: `They said`,
    pressForDetails: `Tap here for details.`,
    close: `Close`,
    addSpecialRequest: `Add Special Request`,
    specialRequest: `Special Request`,
    orderItemWasSuccessfullyCancelled: `Order item was successfully cancelled.`,
    youAreOrderingFromTableside: `You are ordering in {0}, {2}, at table {1}.`,
    youAreOrderingFromTakeout: `You are ordering takeout from {0}, {2}.`,
    youAreOrderingFromDelivery: `You are ordering delivery from {0}, {2}.`,
    youAreOrderingFromTesting: `You are ordering in {0}, at table {1}.`,
    numberOfSplits: `Number of Splits`,
    currentSplit: `Select which split to add items to`,
    clickAnItemToAddItToSplit: `Tap the "+" button on an order item to add it to split {0}.`,
    orderItemAddedToSplit: `Added to split {0}`,
    orderItemAddedToPartialBill: `Added to partial`,
    clickAnItemToAddItToPartial: `Tap the "+" button on an order item to add it to the partial bill.`,
    aSplitArrayIsEmpty: `All splits must contain at least one item or charge before you can request the bill.`,
    totalForRequestedBill: `Total including tax: {0}`,
    totalForRequestedBillWithTip: `Total including tax and a {0}% tip is {1}`,
    totalForRequestedBills: `The total for all split bills will be {0} with taxes included.`,
    ordersThatHaveNotBeenAddedToABill: `To Be Billed For`,
    ordersThatHaveAlreadyBeenAddedToABill: `Already Billed For`,
    showItemsAlreadyBilledFor: `Show Already Billed Items`,
    hideItemsAlreadyBilledFor: `Hide Already Billed Items`,
    alreadyAddedToABill: `Already added to a bill`,
    billForItemsTotal: `{0} item(s) for {1} total`,
    splitBillForItemsTotal: `{0} splits for {1} total`,
    splitTitle: `Split {0}`,
    total: `Total: {0}`,
    billName: `Bill {0}`,
    billDetails: `Bill Details`,
    youveRequestBillsForEverything: `Everything ordered so far has been put onto a requested bill. Thank you for using ${companyName}.`,
    pendingBillsAreAwaitingAResponse: `Pending bills are awaiting a response.`,
    theEstablishmentClosedYouOut: `The establishment has ended this session. Thank you for using ${companyName}.`,
    cannotRequestCancel: `Cannot request cancellation of items already on a pending or accepted bill.`,
    menuPageTutorialTitle: `The Menu`,
    menuPageTutorialMsg: `Welcome to ${companyName}, an app for ordering for yourself or your group. Tap a category, then tap on a menu item that interests you.`,
    termsOfService: `Terms of Service`,
    privacyPolicy: `Privacy Policy`,
    allergiesDisclaimerForFiltersPage: `${companyName} cannot verify the veracity of these filters, if you have a serious allergy or restriction you should double check with the restaurant staff.`,
    allergiesDisclaimerForMenuItemPage: `${companyName} cannot verify the veracity of these attributes, if you have a serious allergy or restriction you should double check with the restaurant staff.`,
    thatItemHasBeenRemovedFromTablesidePendingOrders: `This item was either already accepted or rejected by the kitchen. If it was accepted uou can still request a cancellation of the item via the "Accepted" list, but it will not be guaranteed.`,
    thatItemHasBeenRemovedFromTablesideAcceptedOrders: `This item was already cancelled.`,
    free: `Free`,
    oneTimeCharge: `Ordering one or more items from this category will result in a one time charge of {0}.`,
    howManyIsThisChargeFor: `How many people are you paying this charge for?`,
    chargeNumAddedToSplitPlural: `{0} charges on split {1}`,
    chargeNumAddedToSplitSingular: `{0} charge on split {1}`,
    includeTaxWithPrices: `Include tax with prices and totals`,
    nothingToFilterBuy: `Unfortunately, there are no parameters to filter by.`,
    cookiePolicy: `Cookie Policy`,
    termsAndPrivacy: `By continuing, you are indicating that you accept our Terms of Service and Privacy Policy.`,
    youHaveBeenBanned: `You have been banned from making requests to this restaurant due to malicious behaviour. If you believe this ban was in error, speak with staff and ask them to unban this user ID: {0}. Then refresh this page once they have unbanned you.`,
    banned: `Banned`,
    cannotDoThisInTestingMode: `Cannot do this in a simulated menu.`,
    incognito: `This app cannot work with Incognito Mode enabled since your session with the establishment must be tracked in some way.`,
    showImagesAutomatically: `Show images automatically`,
    showImagesAutomaticallyInfo: `Uncheck this to prevent images from being shown without pressing the "Show Images" button.`,
    referenceName: `Your name`,
    referenceNAmeInfo: `Please provide a name for the order.`,
    readyToOrder: `Ready to Order`,
    language: `Language`,
    expectedWaitTime: `Est. Wait`,
    waitTime: `{0}m`,
    switchToDelivery: `Switch to Delivery`,
    switchToDeliveryTutorial: `This location also offers delivery ordering`,
    switchToTakeout: `Switch to Takeout`,
    switchToTakeoutTutorial: `This location also offers takeout ordering`,
    switchToTableside: `Switch to Tableside`,
    switchToTablesideTutorial: `For ordering when you're sitting at your table`,
    goBackToCodeEntry: `Enter new table code`,
    goBackToCodeEntryTutorial: `If you need to change tables`,
    whatIsNfc: `What is NFC?`,
    whatIsNfcDescription: `<p>NFC is hardware feature that exists on almost all phones (though iPhones released before 2018 require an NFC app).</p><p>To enable NFC on your Android phone, go to Settings > Connection Settings > Enable NFC, or slide down your notification shade and enable it from the quick settings if it is present. NFC is enabled on 2018+ iPhones by default.</p><p>Once NFC is enabled you can tap the rear of your phone to NFC chip to launch ${companyName} and link it to your table. The NFC reader is usually located on the rear top of half of your phone. However, some Galaxy phones have placed it in the center rear.</p>`,
    youRequestedCancellation: `You requested the cancellation of the following item:`,
    promotions: `Promotions`,
    payComingSoon: `In app payment coming soon. Keep an eye on it!`,
    showPaymentForm: `Pay with Card or Paypal`,
    add: `Add`,
    remove: `Remove`,
    tablesidePaidOrders: `Paid Orders`,
    paidTitle: `Paid`,
    paymentSuccessfull: `Your payment of {0} was successful and the vendor has been notified. Thank you for using ${companyName}.`,
    other: `Other`,
    chooseTip: `Choose a tip`,
    retryPayment: `Retry Payment`,
    signInSuccessful: `Sign in successful.`,
    userId: `Your unique identifier is {0}`,
    youPaidForTheseItems: `You paid {0} for these items`,
    startOver: `Start Over`,
    signIn: `Sign In`,
    signInTutorial: `To enable additional features.`,
    signOut: `Sign Out`,
    payForSomeoneElse: `Pay For Someone Else`,
    payForSomeoneElseTutorial: `Pay for items ordered by other people`,
    selectATipToProceed: `Select a tip to proceed.`,
    tablesideOrderAdd: `This order was added`,
    tablesideOrderRemoval: `This order was removed`,
    quantityLowered: `This order had its quantity lowered`,
    quantityIncreased: `This order had its quantity raised`,
    payNow: `Pay Now`,
    payNowTutorialBeforeOrderAccepted: `You can pay once your order has been accepted`,
    payNowTutorialAfterOrderAccepted: `Tap here to go to the pay page.`,
    thanksForFeedback: `Thanks for the feedback! Care to leave a review on Google? We'd really appreciate it!`,
    noThanks: `No Thanks`,
    reviewOnGoogle: `Review on Google`,
    anonymousFeedback: `Anonymous Feedback`,
    howWasYourServer: `How was your server?`,
    howWasYourExperience: `How was the experience?`,
    lowFeedback: `Thanks for the feedback! We'll be sure to do better next time.`,
    mediumFeedback: `Thanks for the feedback!`,
    demoMenu: `Demo Menu`,
    demoMenuWelcome: `Welcome to the ${companyName} Demo. Select the mode and theme you'd like to preview and then click 'Close'.`,
    mode: `Mode`,
    tableside: `Tableside`,
    takeout: `Takeout`,
    viewOnly: `View Only`,
    themes: `Themes`,
    reset: `Reset`,
    yourOrder: `Your Order`,
    payWithCard: `Pay with Card`,
    checkout: `Checkout`,
    payWithCardOption: `Or pay with a credit card:`,
    paymentFailed: `Payment failed`,
    digitalWalletPaymentFailed: `Digital wallet payment failed`,
    payWithDigitalWalletOption: `Press here to pay with a digital wallet like Google Pay or Apple Pay:`,
    paymentAuthorized: `Payment authorized. You'll be charged when the restaurant accepts the order.`,
    additionalDetails: `Additional details (buzzer, instructions etc.)`,
    deliveryAddress: `Delivery Address`,
    saveAsPrimaryAddress: `Save as primary address`,
    accountRequired: `For delivery or takeout ordering, an account is required so we can email you a receipt. It just takes a few taps.`,
    mustBeSignedIn: `Must be signed in`,
    mustBeValidPhoneNumber: `Must be a valid phone number`,
    mustBeValidPostalCode: `Must be a valid postal code`,
    changeDeliveryAddress: `Change Delivery Address`,
    isRequired: `This is required`,
    mustBeLessThan: `Must be less than {0}`,
    validationError: `{0} is invalid. {1}.`,
    pendingDeliveryOrderNumbered: `Pending Delivery Order {0}`,
    pendingTakeoutOrderNumbered: `Pending Takeout Order {0}`,
    acceptedDeliveryOrderNumbered: `Accepted Delivery Order {0}`,
    pendingDeliveryOrder: `Pending Delivery Order`,
    pendingTakeoutOrder: `Pending Takeout Order`,
    acceptedDeliveryOrder: `Accepted Delivery Order`,
    acceptedTakeoutOrder: `Accepted Takeout Order`,
    dispatchedDeliveryOrderNumbered: `Dispatched Delivery Order {0}`,
    dispatchedDeliveryOrder: `Dispatched Delivery Order`,
    readyForPickUpTakeoutOrder: `Ready For Pick Up`,
    selectMenu: `Select a Menu`,
    changeMenu: `Change Menu`,
    sendingPayment: `Sending payment, do not close this window.`,
    inactiveSubscription: `This subscription is not active.`,
    emailForReceipt: `We need an email to send the receipt to.`,
    yourReceiptWillBeSentTo: `The receipt will be sent to {0}.`,
    orderSubmitted: `Order Submitted`,
    kioskOrderCompleteMessage: `Thanks for using ${companyName}. Your receipt will be emailed to you and will include your Pick Up code.`,
    emailRequired: `We need an email to send the receipt to.`,
    comingSoon: `Coming Soon`,
    yourPickUpCodeIs: `Your pick up code for this order is {0}`,
    generalRequests: `General Requests`,
    generalRequestsPlaceholder: `Cutlery, napkins, etc.`,
    asap: `As soon as possible`,
    invalidCCInfo: `Invalid credit card info`,
    infoUpdatedSuccessfully: `Your info was successfully updated.`,
    mustChargeAtLeast50: `Must charge an amount greater than 50 cents.`,
    shouldBeReadyBy: `Should be ready by {0}`,
    soldOut: `Sold Out`,
    id: `ID`,
    establishmentName: `Establishment Name`,
    address: `Address`,
    chargeStatus: `Was Charged?`,
    amountPaid: `Amount Paid`,
    tip: `Tip`,
    noPaymentsMade: `No payments have been completed yet.`,
    pastOrdersInfo: `Your last 10 paid orders will be shown here`,
    pastOrdersTutorial: `See your last 10 paid orders`,
    pastOrders: `Past Orders`,
    pickUpCode: `Pick Up Code`,
    delivery: `Delivery`,
    pendingMessage: `Pending orders aren't charged until they're accepted.`,
    byProceedingYouAgree: `By proceeding you agree to our terms of service and privacy policy.`,
    kioskSignUp: `Sign up and gain access to ${companyName} kiosks anywhere! Once you've made your order we sign you out after.`,
    paymentIntentError: `There was an error in attempting to send the payment. Try refreshing.`,
    contactEmail: `Contact Email`,
    contactNumber: `Contact Number`,
    contactNumberRequired: `A contact number is required`,
    contactEmailRequired: `A contact email is required`,
    referenceNameRequired: `A name is required`,
    contactInfo: `Contact Info`,
    dispatched: `Dispatched`,
    addressLine2: `Unit/Apartment/Suite/Other`,
    enterYourAddress: `Enter your Address`,
    linkIsInvalid: `Link is invalid`,
    orderTypeSelection: `Order Type?`,
    selectLocation: `Select a Location`,
    goToLocationSelection: `Go to location selection`,
    goToLocationSelectionTutorial: `Pick another location or switch your ordering type`,
    signOutInfo: `Only sign out when you're finished with your current order`,
    takeoutIsNotAvailable: `Takeout ordering is not available.`,
    deliveryIsNotAvailable: `Delivery ordering is not available.`,
    tablesideIsNotAvailable: `Tableside ordering is not available.`,
    takeoutIsNoLongerAvailable: `Takeout ordering is no longer available.`,
    deliveryIsNoLongerAvailable: `Delivery ordering is no longer available.`,
    tablesideIsNoLongerAvailable: `Tableside ordering is no longer available.`,
    outsideTakeoutHours: `Takeout ordering is not available at this time.`,
    outsideDeliveryHours: `Delivery ordering is not available at this time.`,
    outsideTablesideHours: `Tableside ordering is not available at this time.`,
    takeoutHours: `Takeout Hours`,
    deliveryHours: `Delivery Hours`,
    showMore: `More`,
    showLess: `Hide`,
    sunday: `Sunday`,
    monday: `Monday`,
    tuesday: `Tuesday`,
    wednesday: `Wednesday`,
    thursday: `Thursday`,
    friday: `Friday`,
    saturday: `Saturday`,
    notOpen: `Not Open`,
    noTakeoutOrDelivery: `No takeout or delivery options currently available for this location.`,
    minimumDeliveryOrderAmount: `Order total with tax and tip is under the minimum amount for delivery.`,
    deliveryOrderMustBeAtLeast: `Your delivery order total with tax and tip must be at least {0}`,
    isOutOfDeliveryRange: `Must be within {0} km for delivery. You are {1} km away.`,
    proceed: `Proceed`,
    needDetailsUserForm: `We just need the following information.`,
    invalidDeliveryAddress: `Invalid delivery address.`,
    invalidGooglePlace: `Invalid delivery address. Type into the address field and pick an address from the dropdown.`,
    keepOriginalAddress: `Keep Original Address`,
    areYouOverYearsOld: `Are you over {0} years old? You must be at least {0} years old to order this.`,
    itemIsAlcoholic: `This item contains alcohol`,
    youAreViewing: `You are viewing the menu for {0}, at {2}`,
    viewMenu: `View Menu`,
    deliveryCharge: `The total includes a delivery charge of {0}`,
    optionSoldOut: `This option is sold out.`,
    notYetVerified: `authorizing...`,
    preferredDeliveryTime: 'Preferred Delivery Time',
    rejectedDeliveryOrder: 'Rejected Delivery Order',
    rejectedTakeoutOrder: 'rejected Takeout Order',
    today: 'Today',
    tomorrow: 'Tomorrow',
    cannotOrderForAPastTime: `Cannot order for a past time.`,
    orderTime: `When is this order for?`,
    rightNow: `Right Now`,
    future: `For Later`,
    whatTimeDoYouWantToOrderFor: `This location is closed for {0} ordering, but you can order ahead.`,
    theLocationIsClosedAndNotOpenSoon: `This location is closed for {0} ordering and will not be open for {0} tommorow either. Please contact the restaurant directly for orders more than one day in advance.`,
    orderTypeSelectionInfoBoth: `This location offers both delivery and takeout ordering.`,
    orderTypeSelectionInfoTakeout: `This location is open for takeout ordering.`,
    orderTypeSelectionInfoDelivery: `This location is open for delivery ordering.`,
    requestedTimeForOrder: `The requested time for this order is {0}`,
    takeoutOrderAhead: 'Takeout (Order Ahead)',
    deliveryOrderAhead: 'Delivery (Order Ahead)',
    orderForLater: 'Order for later',
    everyDay: 'Every day.',
    backToLocationSelection: 'Back to Location Selection',
    exitToCodeEntry: 'Exit to code entry',
    cannotMakeAnOrderForAPastDate: 'Cannot make an order for a past date.',
    confirmLabel: `Confirm`,
    takeoutTutorial: 'Order takeout to pick up',
    takeoutOrderAheadTutorial: 'Order takeout a future time',
    deliveryTutorial: 'Order delivery to your location',
    deliveryOrderAheadTutorial: 'Order delivery for a future time',
    viewOnlyTutorial: 'View the menu without ordering',
    getAppUnknown: `Tap the three dot menu icon. Then tap "Add to Home screen".`,
    getAppFirefox: `Tap the house icon with the plus inside of it by the URL bar. Then tap "Add to Home screen".`,
    getAppEdge: `Tap the three dot menu icon at the bottom of the browser. Then tap "Add to Home screen".`,
    getAppChrome: `Tap the three dot menu button on the top right of the browser. Then tap "Add to Home screen" or "Install...".`,
    requestingLocationModalTitle: 'Location Permission',
    requestingLocationForLocationSorting: 'To view the closest locations please grant Tap Menu location permissions.',
    requestingLocationForTablesideOrdering: 'To ensure that you are ordering from the correct place, please grant location permissions.',
    requestingNotificationsModalTitle: 'Notification Permission',
    requestingNotificationsModalDescription: 'For us to notify you of your orders status in real time, please grant notification permissions.',
    weAreClosedToday: 'We are closed today.',
    payOnlineOrInPerson: 'Pay Online or in Person?',
    inPerson: 'In Person',
    online: 'Online',
    cannotMakeSelectionsInViewOnlyMode: 'Cannot make selections in view only mode.',
    contactTracing: 'For purposes of COVID-19 contact tracing we ask you to provide the following.',
    yourOrderIsReadyForPickUp: 'Your order is ready for pick up.',
    yourDeliveryOrderIsOnItsWay:  'Your delivery order is on its way.',
    cannotSendEmptyMessage: 'Cannot send an empty message.',
    guestCheckout: 'Guest Checkout',
    guestCheckoutInfo: 'By checking out as a guest you will be unable to save your data/receipts/preferences across devices. Is this okay?',
    chatDisabledInfo: 'This location has disabled chatting, but you can still see order information on this page',
    removeAll: 'Remove All',
    removeOne: 'Remove One',
    couldNotProceed: 'Could Not Proceed',
    gdprTitle: `GDPR Notice`,
    gdprMessage: `By using this website, you agree to our use of cookies. We use cookies to provide you with a great experience and to help our website run effectively.`,
    // To translate
    paid: 'Paid',
    billed: 'Billed',
  },
};
